import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface SectionHeaderProps {
  eyebrow?: string;
  title: string;
  description?: string;
  icon?: LucideIcon;
  actions?: ReactNode;
  className?: string;
}

export default function SectionHeader({
  eyebrow,
  title,
  description,
  icon: Icon,
  actions,
  className,
}: SectionHeaderProps) {
  return (
    <div className={cn("flex items-end justify-between gap-3 mb-3", className)}>
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-[10px] font-heading font-bold uppercase tracking-[0.18em] text-primary/80 mb-1">
            {eyebrow}
          </p>
        )}
        <div className="flex items-center gap-2">
          {Icon && <Icon className="w-4 h-4 text-primary shrink-0" />}
          <h2 className="font-heading font-bold text-base sm:text-lg text-foreground">
            {title}
          </h2>
        </div>
        {description && (
          <p className="text-xs text-muted-foreground mt-0.5">{description}</p>
        )}
      </div>
      {actions && <div className="shrink-0">{actions}</div>}
    </div>
  );
}